import { createAction } from "redux-actions";

export const setRoles = createAction("SET_ROLES");